// extracted by mini-css-extract-plugin
export var container = "guests-module--container--e9KOx";
export var guestsContainer = "guests-module--guestsContainer--E5Faa";
export var intro = "guests-module--intro--dvVBa";
export var guests = "guests-module--guests--9zKb2";
export var guest = "guests-module--guest--C4aJY";
export var guestImg = "guests-module--guestImg--6U6Mb";
export var guestDesc = "guests-module--guestDesc--5-0LF";